import { LegalDocumentType } from '@api/hooks/useProfiles';

export interface LegalDocument {
	labelKey: string;
	tabLabelKey: string;
	namespace: string;
}

export const LEGAL_DOCUMENTS: Record<LegalDocumentType, LegalDocument> = {
	[LegalDocumentType.TERMS_AND_CONDITIONS]: {
		labelKey: 'legalConsent.termsLabel',
		tabLabelKey: 'legalConsent.tabTerms',
		namespace: 'termsAndConditions',
	},
	[LegalDocumentType.PRIVACY_POLICY]: {
		labelKey: 'legalConsent.privacyLabel',
		tabLabelKey: 'legalConsent.tabPrivacy',
		namespace: 'privacyPolicy',
	},
};
